import { DeviceDetailDto } from '@groundfloor-platform/mgmt-service-g-sdk';

export interface TrmmAgentMesh {
  hostname: string;
  control: string; // The iFrame URL for remote control
  terminal: string; // The iFrame URL for terminal/commands
  file: string; // The iFrame URL for file browser
  status: string;
  client: string;
  site: string;
}

export type TrmmViewKind = 'control' | 'terminal' | 'file';

export function extractTrmmAgentMesh(detail: DeviceDetailDto | undefined): TrmmAgentMesh | undefined {
  const mesh = detail?.mesh as Partial<TrmmAgentMesh> | undefined;
  if (!mesh || typeof mesh.control !== 'string') return undefined;
  return mesh as TrmmAgentMesh;
}
